import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { TableModule } from '@openng/optimus-ui/table';
import { SvgIconsComponent } from '@zayan-erp/shared';
import { Product, ProductService } from '@zayan-erp/home-building';
import { ProductPreviewCardComponent } from '../product-preview-card/product-preview-card.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { map, of, tap } from 'rxjs';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-product-linked-products',
  imports: [TableModule, SvgIconsComponent, ProductPreviewCardComponent, FormsModule, NgbDropdownModule],
  templateUrl: './product-linked-products.component.html',
  standalone: true
})
export class ProductLinkedProductsComponent {
  #productService = inject(ProductService);
  #activatedRoute = inject(ActivatedRoute);

  search = signal<string>('');
  selectedProducts = signal<Product[]>([]);
  productId = signal<string | null>(this.#activatedRoute.snapshot.paramMap.get('id'));
  products = rxResourceFixed({
    params: () => ({}),
    defaultValue: [],
    stream: ({ params }) => this.#productService.readRegularProducts()
  });

  productDetails = rxResourceFixed({
    params: () => ({ productId: this.productId()! }),
    defaultValue: {} as Product,
    stream: ({ params }) => {
      return this.#productService.readProductById(params.productId!);
    }
  });

  productListId = computed(() => this.productDetails.value()?.productListId);
  productClassId = computed(() => this.productDetails.value()?.productClassId);

  listProducts = rxResourceFixed({
    params: () => ({ productListId: this.productListId()! }),
    defaultValue: [],
    stream: ({ params }) => {
      return this.#productService.readProducts(params.productListId!, '', '', 1, 1000).pipe(
        map((products: { items: Product[]; totalCount: number }): Product[] =>
          products.items.filter(
            (product: Product) => product.productClassId !== this.productClassId() && product.id !== this.productId()!
          )
        ),
        tap((products: Product[]) => {
          console.log('list products', products);
        })
      );
    }
  });

  productList = computed(() =>
    this.listProducts
      .value()
      ?.filter(product => product.code.toLowerCase().includes(this.search().toLowerCase()))
      .filter(
        product => !this.linkedProducts.value()?.some(linkedProduct => linkedProduct.linkedProduct.id === product.id)
      )
  );

  linkedProducts = rxResourceFixed({
    params: () => ({ productId: this.productId()! }),
    defaultValue: [],
    stream: ({ params }) => {
      if (params.productId) {
        return this.#productService.readLinkedProducts(params.productId!);
      }
      return of([]);
    }
  });
  linkedProductList = computed(() => {
    this.linkedProducts.value();
    return this.linkedProducts.value();
  });

  submitLinkedProducts(product: Product) {
    this.#productService.linkProduct(this.productId()!, product.id!).subscribe({
      next: () => {
        this.linkedProducts.reload();
      }
    });
  }
  deleteLinkedProduct(id: string) {
    this.#productService.deleteLinkedProduct(id).subscribe({
      next: () => {
        this.linkedProducts.reload();
      }
    });
  }
}
